import { FC } from 'react';
import { Spin } from 'antd';

export const TenantBrandingSettingsLoading: FC = () => {
  return <Spin />;
};
